import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";

export function UseFractionalList() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getFractionalList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_FractionalList?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getFractionalByDate = (myPC, Date, isFractional, callback) => {
    MyAxios.get(
      `Admin_FractionalList/${Date}/${isFractional ? isFractional : ""}`,
      {
        headers: {
          Conditions: JSON.stringify({ pageCondition: myPC }),
        },
      },
    ).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getOrderById = (orderId, callback) => {
    MyAxios.get(`Admin_FractionalList/Order/${orderId}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const addAllOrderMissing = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_FractionalList/Missingdate`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };
  const addOneOrderMissing = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_FractionalList/MissingID`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getFractionalList,
    getFractionalByDate,
    getOrderById,
    addAllOrderMissing,
    addOneOrderMissing,
  };
}
